/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrowLeft': {
    width: 50,
    height: 50,
    viewBox: '0 0 50 50',
    data: '<path pid="0" d="M1 25.004c.02.5.229 1.08.574 1.444l11.294 11.9c.766.682 2.233.963 3.088.176.844-.777.816-2.284-.022-3.063l-7.941-8.357h38.89a2.11 2.11 0 002.117-2.1c0-1.16-.949-2.1-2.118-2.1H7.992l7.942-8.358c.722-.719.857-2.278.022-3.062-.833-.785-2.355-.534-3.088.175l-11.294 11.9c-.344.363-.53.781-.567 1.261L1 25.004z" _fill="#4F8199" fill-rule="evenodd"/>'
  }
})
